'use client';

import { useTranslations } from 'next-intl';
import BaseSidebarLayout from '@/components/common/BaseSidebarLayout';
import { useParams } from 'next/navigation';

type Props = {
    children: React.ReactNode;
};

export default function ServicesLayout({ children }: Props) {
    const params = useParams();
    const locale = params.locale as string;
    const t = useTranslations('ServicesPage');

    const menuItems = [
        { id: 'general-info', label: t('generalInfo'), href: `/${locale}/services/general-info` },
        { id: 'auction-access', label: t('auctionAccess'), href: `/${locale}/services/auction-access` },
        {
            id: 'domestic-transportation',
            label: t('domesticTransportation'),
            href: `/${locale}/services/domestic-transportation`,
        },
        { id: 'global-shipping', label: t('globalShipping'), href: `/${locale}/services/global-shipping` },
        { id: 'faq', label: t('faq'), href: `/${locale}/services/faq` },
    ];

    return (
        <BaseSidebarLayout menuItems={menuItems} title={t('title')}>
            {children}
        </BaseSidebarLayout>
    );
}
